<script setup lang="ts">
import { ref } from 'vue';
import Lock from './icons/Lock.vue';
import X from './icons/X.vue';

const isVisible = ref(true);

const close = () => {
  isVisible.value = false;
};
</script>

<template>
  <div v-if="isVisible" class="bg-gray-100/80 border-b border-gray-200 text-gray-600 px-4 py-2">
    <div class="max-w-7xl mx-auto flex items-center justify-between gap-2">
      <div class="flex items-center gap-2">
        <Lock class="w-4 h-4 flex-shrink-0 text-gray-400" />
        <span class="text-sm">{{ $t('workshop.votingLocked') }}</span>
      </div>
      <button
        @click="close"
        class="cursor-pointer p-1 hover:bg-gray-200 rounded transition-colors"
        :aria-label="$t('common.close')"
      >
        <X class="w-4 h-4" />
      </button>
    </div>
  </div>
</template>
